module.exports = __webpack_public_path__ + "static/media/gaypec.78aa5be7.png";